'use strict';

/**
 * @ngdoc function
 * @name thothApp.controller:ProjectCtrl
 * @description
 * # ProjectCtrl
 * Controller of the thothApp
 */
angular.module('thothApp.controllers')
  .controller('ProjectCtrl', function() {
  });
